<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition-group
    name="toast"
    enter-active-class="transform transition-all duration-500"
    enter-from-class="translate-x-72 opacity-0"
    enter-to-class="translate-x-0 opacity-100"
    leave-active-class="transform transition-all duration-500"
    leave-from-class="translate-x-0 opacity-100"
    leave-to-class="translate-x-72 opacity-0"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition-group>
</template>
